import { NavLink, useNavigate } from "react-router-dom";
import {useEffect, useState } from "react";
import JobZImage from "../../../../common/jobz-img";
import { publicUser } from "../../../../../globals/route-names";
import axiosInstance from '../../../../../axiosInstance';
import { API_URL } from "../../../../../config";

const loginUser = async (userData, navigate) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/admin/admin-login`, userData);
        if (response.data.token) {
            localStorage.setItem("authToken", response.data.token);
            localStorage.setItem("role", response.data.data.role)
            navigate("/employer/dashboard");
            window.location.reload();
            return { success: true, message: "Login successful!" };
        } else {
            return { success: false, message: response.data.message || "Login failed" };
        }
    } catch (error) {
        const errorMessage = error.response?.data?.error || "Invalid email or password";
        return { success: false, message: errorMessage };
    }
};

function LoginPage() {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [message, setMessage] = useState({ text: '', type: '' });

    useEffect(() => {
        const authToken = localStorage.getItem("authToken");
        const role = localStorage.getItem("role");
        if (authToken && role === "admin") {
            navigate("/employer/dashboard");
        }
    }, []);

    const handleLogin = async (event) => {
        event.preventDefault();

        if (!email || !password) {
            setMessage({ text: "All fields are required", type: 'error' });
            return;
        }

        const userData = { loginType: "email", email, password };
        const result = await loginUser(userData, navigate);

        if (result.success) {
            setMessage({ text: result.message, type: 'success' });
            setEmail("");
            setPassword("");
        } else {
            setMessage({ text: result.message, type: 'error' });
        }
    };

    return (
        <div className="section-full site-bg-white">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xl-8 col-lg-6 col-md-5 twm-log-reg-media-wrap">
                        <div className="twm-log-reg-media">
                            <JobZImage src="images/login-bg.png" alt="" />
                        </div>
                    </div>
                    <div className="col-xl-4 col-lg-6 col-md-7">
                        <div className="twm-log-reg-form-wrap">
                            <div className="twm-log-reg-logo-head">
                                <NavLink to={publicUser.HOME1}>
                                    <JobZImage src="images/skins-logo/logo-skin-5.png" alt="" className="logo" />
                                </NavLink>
                            </div>
                            <div className="twm-log-reg-inner">
                                <div className="twm-log-reg-head">
                                    <span className="log-reg-form-title">Log In</span>
                                </div>
                                <div className="twm-tabs-style-2">
                                    <div className="tab-content">
                                        <form onSubmit={handleLogin} className="tab-pane fade show active" id="twm-login-candidate">
                                            {message.text && (
                                                <div className={`alert ${message.type === 'success' ? 'alert-success' : 'alert-danger'}`} role="alert">
                                                    {message.text}
                                                </div>
                                            )}
                                            <div className="form-group mb-3">
                                                <input
                                                    type="text"
                                                    required
                                                    className="form-control"
                                                    placeholder="Email*"
                                                    value={email}
                                                    onChange={(e) => {
                                                        setEmail(e.target.value);
                                                        if (message.text) setMessage({ text: '', type: '' });
                                                    }}
                                                />
                                            </div>
                                            <div className="form-group mb-3">
                                                <input
                                                    type="password"
                                                    required
                                                    className="form-control"
                                                    placeholder="Password*"
                                                    value={password}
                                                    onChange={(e) => {
                                                        setPassword(e.target.value);
                                                        if (message.text) setMessage({ text: '', type: '' });
                                                    }}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <button type="submit" className="site-button">Log in</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default LoginPage;